<template>
    <span>
        <div class="is-flex v-centered">
            <a @click="experiment.show = !experiment.show">
                <!-- Vue.js 'v-if' and Bulma <i> did not play nice together -->
                <span v-show="experiment.show" class="icon">
                    <i
                        class="fa fa-caret-down fa-lg has-text-black"
                        key="down"
                    ></i>
                </span>
                <span v-show="!experiment.show" class="icon">
                    <i
                        class="fa fa-caret-right fa-lg has-text-black"
                        key="right"
                    ></i>
                </span>
            </a>
            <MetadataLink :metadata="experiment" />
        </div>

        <div v-if="experiment.show">
            <ul class="menu-list">
                <li class="menu-label is-flex v-centered">
                    <img
                        :src="`${ASSETS_BASE_URL}datamodel/icons/SVG/chan-light.svg`"
                        alt="BossDB DataType Icon"
                        style="height: 1.7em; padding-right: 10px"
                    />
                    <span class="label-color">Channels</span>
                </li>
                <li
                    class="indented"
                    v-for="channel in experiment.channels.slice(
                        0,
                        experiment.displayRange
                    )"
                >
                    <MetadataLink :metadata="channel" />
                </li>
                <template
                    v-if="
                        experiment.channels.length > experiment.displayRange + 1
                    "
                >
                    <li class="indented">
                        <a
                            @click="experiment.displayRange += maxItems"
                            style="margin:0"
                            >...</a
                        >
                    </li>
                    <li class="indented">
                        <MetadataLink
                            :metadata="experiment.channels.slice(-1)[0]"
                        />
                    </li>
                </template>
            </ul>
        </div>
    </span>
</template>

<script>
import { ASSETS_BASE_URL } from "@/assets.js";
import MetadataLink from "./MetadataLink.vue";

export default {
    name: "ExperimentDropdown",
    props: {
        exp: Object
    },
    components: {
        MetadataLink
    },

    created() {
        this.maxItems = 10;
        this.experiment = {
            id: this.exp.id,
            name: this.exp.name,
            metadataUrl: this.exp.metadataUrl,
            channels: this.exp.channels,
            show: this.exp.show,
            displayRange: this.exp.displayRange
        };
    },
    data() {
        return {
            ASSETS_BASE_URL,
            experiment: this.experiment,
            maxItems: this.maxItems
        };
    }
};
</script>

<style lang="scss">
.justify-between {
    justify-content: space-between;
}
</style>
